var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceModels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "device-models",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect8872",
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1083",
    d: "M5.576,8A1.867,1.867,0,0,0,3.7,9.875V28h9.187V25.188H5.576V9.875H27.2V28a1.867,1.867,0,0,0,1.875-1.875V9.875A1.867,1.867,0,0,0,27.2,8H5.576Zm10.407,3.75a1.178,1.178,0,0,0-1.219,1.218V26.626a1.467,1.467,0,0,0,.344.952,1.081,1.081,0,0,0,.875.422h8.5a1.6,1.6,0,0,0,1.078-.391,1.243,1.243,0,0,0,.453-.984V12.968a1.031,1.031,0,0,0-.469-.89,1.807,1.807,0,0,0-1.062-.328Zm.656,1.875h7.5V25.188h-7.5Z",
    transform: "translate(-1.388 -3)",
    fill: "rgba(0,0,0,0.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceModels);
export default __webpack_public_path__ + "static/media/Device-models.c8df3f5de7d0db3f28214df71fbc13b9.svg";
export { ForwardRef as ReactComponent };